export const IS_PLACEHOLDER_KEY = '__isPlaceholder';
export const ROW_HEIGHT = 30;
export const CELL_X_PADDING = 22;

export const ENTRY_PLACEHOLDER = {
  [IS_PLACEHOLDER_KEY]: true,
};
